import React, { useEffect, useState } from "react";

import collaboratorServices from "../../../../services/admFin/collaboratorServices";
import reportServices from "../../../../services/reportServices";
import compare from '../../../../functions/compare';

import ActivityIndicator from "../../../../components/ActivityIndicator";
import Card from '../../../../components/Card';
import CardItem from '../../../../components/CardItem';
import PopupReports from "../../../../components/PopupReports";
import { CollaboratorInfoPopUp } from "./CollaboratorInfoPopUp";
import CollaboratorPopUp from "./CollaboratorPopUp";
import { PopupCollaboratorReport } from "./PopupCollaboratorReport";
import { FaFilter, FaPen, FaPlus, FaPrint, FaTrash } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";

import "./styles.css";
import FilterCollaboratorsPopUp from "./FilterCollaboratorsPopUp";


export default function CollaboratorsCard(props) {
    const [visibility, setVisibility] = useState(false);
    const [visibilityEdit, setVisibilityEdit] = useState(false);
    const [visibilityReport, setVisibilityReport] = useState(false);
    const [visibleInfo, setVisibleInfo] = useState(false);
    const [visibilityFilter, setVisibilityFilter] = useState(false);
    const [collaboratorInfo, setCollaboratorInfo] = useState({});
    const [collaboratorsToShow, setCollaboratorsToShow] = useState([]);

    const [showElements, setShowElements] = useState(false);
    const collaborators = props.collaborators;

    useEffect(() => {
        if(collaborators && collaborators.length > 0)
            setCollaboratorsToShow(collaborators);
    }, [collaborators])

    async function createCollaborator(collaboratorData) {
        console.log(collaboratorData);
        console.log("Empresas", collaboratorData.empresas);

        if (!collaboratorData.nome ||
            !collaboratorData.documento ||
            !collaboratorData.salario ||
            !collaboratorData.cargo ||
            !collaboratorData.ferias ||
            /* !collaboratorData.telefone ||
            !collaboratorData.ddi ||
            !collaboratorData.iso2 || */
            /* !collaboratorData.logradouro ||
            !collaboratorData.cidade ||
            !collaboratorData.estado ||
            !collaboratorData.bairro ||
            !collaboratorData.cep  */
            !collaboratorData.data_admissao ||
            (collaboratorData.inativo && !collaboratorData.data_demissao)
        ) {
            alert("Os campos devem estar preenchidos");
            return;
        }
        try {
            var newCollaborator = null, response = await collaboratorServices.postCollaborator(
                collaboratorData.nome,
                collaboratorData.data_admissao,
                collaboratorData.inativo,
                collaboratorData.data_demissao,
                collaboratorData.documento,
                collaboratorData.telefone,
                collaboratorData.ddi,
                collaboratorData.iso2,
                collaboratorData.logradouro,
                collaboratorData.cidade,
                collaboratorData.bairro,
                collaboratorData.estado,
                collaboratorData.cep,
                collaboratorData.foto,
                collaboratorData.observacao,
                collaboratorData.salario,
                collaboratorData.cargo,
                collaboratorData.ferias,
            );
            newCollaborator = response.data;
            try {
                let response = await collaboratorServices.postLinkCollaboratorCompanys(newCollaborator.id, collaboratorData.empresas);
                newCollaborator = response.data;
            } catch (err) {
                alert("Não foi possível registrar as empresas do colaborador");
            }
            props.setCollaborators(oldArray => {
                const temp = [...oldArray];
                temp.push(newCollaborator);
                temp.sort((a, b) => compare(a.nome, b.nome));
                return temp;
            })
            setVisibility(false);
        } catch (err) {
            alert("Não foi possível criar a colaborador");
        }
    }

    async function editCollaborator(collaboratorData) {
        console.log(collaboratorData);
        console.log("Empresas", collaboratorData.empresas);
        if (!collaboratorInfo.id ||
            !collaboratorData.nome ||
            !collaboratorData.documento ||
            !collaboratorData.salario ||
            !collaboratorData.cargo ||
            !collaboratorData.ferias ||

            /* !collaboratorData.telefone ||
            !collaboratorData.ddi ||
            !collaboratorData.iso2 || */
            /* !collaboratorData.logradouro ||
            !collaboratorData.cidade ||
            !collaboratorData.estado ||
            !collaboratorData.bairro ||
            !collaboratorData.cep  */
            !collaboratorData.data_admissao ||
            (collaboratorData.inativo && !collaboratorData.data_demissao)
        ) {
            alert("Os campos devem estar preenchidos");
            return;
        }
        try {
            var newCollaborator = null, response = await collaboratorServices.patchCollaborator(
                collaboratorInfo.id,
                collaboratorData.nome,
                collaboratorData.data_admissao,
                collaboratorData.inativo,
                collaboratorData.data_demissao,
                collaboratorData.documento,
                collaboratorData.telefone,
                collaboratorData.ddi,
                collaboratorData.iso2,
                collaboratorData.logradouro,
                collaboratorData.cidade,
                collaboratorData.bairro,
                collaboratorData.estado,
                collaboratorData.cep,
                collaboratorData.foto,
                collaboratorData.observacao,
                collaboratorData.salario,
                collaboratorData.cargo,
                collaboratorData.ferias,
            );
            newCollaborator = response.data;
            try {
                response = await collaboratorServices.postLinkCollaboratorCompanys(newCollaborator.id, collaboratorData.empresas);
                newCollaborator = response.data;
            } catch (err) {
                alert("Não foi possível editar as empresa do colaborador");
            }
            props.setCollaborators(oldArray => {
                return oldArray.map(obj => obj.id === collaboratorInfo.id ? newCollaborator : obj);
            })
            setVisibilityEdit(false);
        } catch (err) {
            alert("Não foi possível editar o colaborador");
        }
    }

    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportCollaborators(collaboratorsToShow, "RELATÓRIO DE COLABORADORES", fields, fileName);
        } catch (err) {
            alert(err.message);
            return false;
        }
    }

    return (
        <Card
            tittle={props.tittle}
            options={
                <>
                    <button onClick={() => setVisibilityFilter(!visibilityFilter)} className="records-filter-button"><FaFilter /></button>
                    <FilterCollaboratorsPopUp
                        visibility={visibilityFilter}
                        setVisibility={setVisibilityFilter}
                        collaborators={collaborators}
                        companies={props.companies}
                        setCollaboratorsToShow = {setCollaboratorsToShow}
                    />

                    <button onClick={() => setVisibility(!visibility)} className="records-new-item-button"><FaPlus /></button>
                    <CollaboratorPopUp
                        tittle="Novo Colaborador"
                        buttonTittle="Criar"
                        visibility={visibility}
                        setVisibility={setVisibility}
                        onClick={createCollaborator}
                        companies={props.companies}
                    />
                    <button title="Relatório" onClick={() => setVisibilityReport(true)} className="records-new-item-button"><FaPrint /></button>
                    <PopupReports
                        visibility={visibilityReport}
                        setVisibility={setVisibilityReport}
                        tittle={`Relatório de Colaboradores`}
                        fields={reportServices.collaboratorFields}
                        generateReport={generateReport}
                    />

                    <button
                        onClick={() => setShowElements(!showElements)}
                        className={"records-hide-elements-button" + (showElements ? " showing" : "")}
                    >
                        <IoIosArrowDown />
                    </button>
                </>
            }
        >
            {
                !showElements ?
                    null
                    :
                    <div className="records-elements">
                        {
                            collaboratorsToShow && collaboratorsToShow.length ?
                                <>
                                    <CollaboratorInfoPopUp
                                        visibility={visibleInfo}
                                        setVisibility={setVisibleInfo}
                                        collaborator={collaboratorInfo}
                                    />
                                    <CollaboratorPopUp
                                        visibility={visibilityEdit}
                                        setVisibility={setVisibilityEdit}
                                        tittle="Editar Colaborador"
                                        buttonTittle="Editar"
                                        collaborator={collaboratorInfo}
                                        onClick={editCollaborator}
                                        companies={props.companies}
                                    />
                                    {/* <PopupCompanyReport
                                        visibility={visibilityReportCompany}
                                        setVisibility={setVisibilityReportCompany}
                                        companyInfo={empresaInfo}
                                    /> */}
                                    {
                                        collaboratorsToShow.map((collaborator) =>
                                            <div className="records-element-container" key={collaborator.id}>
                                                <div
                                                    onClick={() => {
                                                        setCollaboratorInfo(collaborator);
                                                        setVisibleInfo(!visibleInfo);
                                                    }}
                                                >
                                                    <CardItem
                                                        removeLeftSpace
                                                        bodyOptions={<span className="tag">COD {collaborator.id}</span>}
                                                    >
                                                        <div className="collaborator-item-info-container">
                                                            <div>
                                                                {
                                                                    collaborator.foto ?
                                                                    <img className="collaborator-item-image" src={collaborator.foto} alt="Foto do Colaborador"/>
                                                                    :
                                                                    <div className={'photo-preview-collaborator'} />
                                                                }
                                                    
                                                                <h4>
                                                                    {collaborator.nome}
                                                                </h4>
                                                            </div>
                                                            <span><p className={!collaborator.inativo ? "active" : "inactive"}>{!collaborator.inativo ? "Ativo" : "Inativo"}</p></span>
                                                        </div>
                                                    </CardItem>
                                                </div>
                                                <button onClick={() => {
                                                    setCollaboratorInfo(collaborator);
                                                    setVisibilityEdit(true);
                                                }}>
                                                    <FaPen />
                                                </button>

                                                {/* <button onClick={() => {
                                                    setCollaboratorInfo(collaborator);
                                                    setVisibilityReportcollaborator(true);
                                                }}>
                                                    <FaPrint />
                                                </button> */}
                                                <button className="red" onClick={() => props.deleteElement(collaborator.id, collaboratorServices.deleteCollaborator, props.setCollaborators)}>
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        )
                                    }
                                </>
                                :
                                <ActivityIndicator />
                        }
                    </div>
            }
        </Card>

    )
}